/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import { ResponsiveContext } from 'grommet';
import styled from 'styled-components';

import Header from './Header';
import Footer from './Footer';
import { getThemeColor } from '../theme';

const ResponsiveMain = ({ children, screenSize }) => {
  const Main = styled.main`
    background: ${getThemeColor('brand-light-gray')};
  `;

  return <Main>{children}</Main>;
};

const Layout = ({ children }) => {
  const screenSize = React.useContext(ResponsiveContext);
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} />
      <ResponsiveMain screenSize={screenSize}>{children}</ResponsiveMain>
      <Footer />
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
